import { render, staticRenderFns } from "./TrendSearch.vue?vue&type=template&id=615a9e97&scoped=true"
import script from "./TrendSearch.vue?vue&type=script&lang=js"
export * from "./TrendSearch.vue?vue&type=script&lang=js"
import style0 from "./TrendSearch.vue?vue&type=style&index=0&id=615a9e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a9e97",
  null
  
)

export default component.exports